import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import App from '../App.vue'
import ImagePreview from "../components/ImagePreview.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      redirect: '/pages/dein-eigenes-foto'
    },
    {
      path: '/pages/dein-eigenes-foto',
      name: 'produktansicht',
      component: HomeView,
      props: route => ({ query: route.query.v })
    },
    {
      path: '/wandansicht',
      name: 'wandansicht',
      props: { default: true, wand: true },
      component: HomeView,
    },
    {
      path: '/vorschau',
      name: 'vorschau',
      component: HomeView,
      props: route => ({ query: route.query.v })
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import('../views/AboutView.vue')
    }
  ]
})

function hasQueryParams(route) {
  return !!Object.keys(route.query).length
}

router.beforeEach((to, from, next) => {
  if(!hasQueryParams(to) && hasQueryParams(from)){
    next({name: to.name, query: from.query});
  } else {
    next()
  }
})

export default router
